import React from 'react';

import NewContactForm from './NewContactForm';

/* eslint-disable */
class PrivateDining extends React.Component {
	render() {
    const { body } = this.props;
		return (
			<div className="main-content-body-inner-container">
        <div className="main-content-body-title">
        PRIVATE DINING
        </div>
        <div className="main-content-text-container main-content-body-scrollable-box">
          {body ? (
						<div>
							<div
								className="body-html-box"
								dangerouslySetInnerHTML={{ __html: body }}
							/>
							<NewContactForm />
							<div>
								<img src="/imgs/private_dinning.jpeg" alt="same-same-private-dinning" width="100%" />
							</div>
						</div>
					) : null}
        </div>
			</div>
		);
	}
}

export default PrivateDining;



// WEBPACK FOOTER //
// ./src/Theme/PrivateDining.jsx